/* CheckNCheer: turns team <select>s into a logo picker. The native select stays in the DOM as the source of truth,
   so existing change listeners and `sel.value = x` keep working. */
(function(){
  if(window.__ctp) return; window.__ctp = 1;
  var SEL = 'select[data-cnc-set-pick],select[data-cnc-qv-pick],select[data-team],select[data-xc-select]';
  var pop = null, popFor = null;
  function key(s){ return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function logo(name){ var t = (window.CNC_TEAMS || {})[key(name)]; return t ? t[0] : ''; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function face(name){ var u = logo(name); return (u ? '<img src="' + esc(u) + '" alt="" width="40" height="40">' : '') + '<span>' + esc(name) + '</span>'; }
  function sync(sel){
    var o = sel.options[sel.selectedIndex], b = sel.__ctp; if(!b) return;
    b.querySelector('.ctp__face').innerHTML = o ? face(o.text.trim()) : '';
    b.hidden = sel.hidden || !sel.options.length;
  }
  function close(){ if(pop){ pop.remove(); pop = null; if(popFor) popFor.__ctp.setAttribute('aria-expanded', 'false'); popFor = null; } }
  function tiles(sel, opts){
    return opts.map(function(o){ var n = o.text.trim(), on = o.value === sel.value;
      return '<button type="button" class="ctp__tile' + (on ? ' is-on' : '') + '" data-v="' + esc(o.value) + '" aria-pressed="' + on + '">' + face(n) + '</button>'; }).join('');
  }
  function open(sel){
    var same = popFor === sel; close(); if(same) return;
    var html = '', gs = sel.querySelectorAll('optgroup');
    if(gs.length) [].forEach.call(gs, function(g){ html += '<p class="ctp__g">' + esc(g.label) + '</p><div class="ctp__grid">' + tiles(sel, [].slice.call(g.children)) + '</div>'; });
    else html = '<div class="ctp__grid">' + tiles(sel, [].slice.call(sel.options)) + '</div>';
    pop = document.createElement('div'); pop.className = 'ctp__pop'; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', 'Pick a team');
    pop.innerHTML = '<div class="ctp__head"><b>Pick a team</b><button type="button" class="ctp__x" aria-label="Close">&times;</button></div><div class="ctp__body">' + html + '</div>';
    (sel.closest('dialog') || document.body).appendChild(pop); popFor = sel; sel.__ctp.setAttribute('aria-expanded', 'true');
    pop.addEventListener('click', function(e){
      e.stopPropagation();
      if(e.target.closest('.ctp__x')){ close(); return; }
      var t = e.target.closest('.ctp__tile'); if(!t) return;
      sel.value = t.dataset.v; close(); sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if(innerWidth > 749){
      var r = sel.__ctp.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
      pop.style.left = Math.max(12, Math.min(r.left, innerWidth - w - 12)) + 'px';
      pop.style.top = (r.bottom + h + 8 > innerHeight && r.top - h - 8 > 0 ? r.top - h - 8 : Math.min(r.bottom + 8, innerHeight - h - 12)) + 'px';
    }
    var cur = pop.querySelector('.is-on'); if(cur) cur.scrollIntoView({ block: 'nearest' });
  }
  function wire(sel){
    if(sel.__ctp) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'ctp__btn'; b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-label', 'Team');
    b.innerHTML = '<span class="ctp__face"></span><svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    sel.__ctp = b; sel.classList.add('ctp__native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    sel.parentNode.insertBefore(b, sel.nextSibling);
    b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); open(sel); });
    ['value', 'selectedIndex'].forEach(function(p){
      var d = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, p);
      Object.defineProperty(sel, p, { configurable: true, get: function(){ return d.get.call(sel); }, set: function(v){ d.set.call(sel, v); sync(sel); } });
    });
    sel.addEventListener('change', function(){ sync(sel); });
    new MutationObserver(function(){ sync(sel); }).observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    sync(sel);
  }
  function run(){
    var list = document.querySelectorAll(SEL); if(!list.length) return;
    function go(){ [].forEach.call(list, wire); }
    if(window.CNC_TEAMS || !window.CNC_TEAMS_URL) return go();
    var s = document.createElement('script'); s.src = window.CNC_TEAMS_URL; s.onload = s.onerror = go; document.head.appendChild(s);
  }
  document.addEventListener('click', function(e){ if(pop && !pop.contains(e.target)) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  addEventListener('resize', close);
  addEventListener('scroll', function(){ if(pop && innerWidth > 749) close(); }, { passive: true });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
